type MallUnderlinePrice = string | number | null | undefined

export const normalizeMallUnderlinePrice = (value: MallUnderlinePrice) => {
    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
        return null
    }

    return value
}

export const buildMallDisplayPayload = (underlinePrice: MallUnderlinePrice) => ({
    mall_display: {
        underline_price: normalizeMallUnderlinePrice(underlinePrice),
    },
})
